'use strict';

var actions = require('../actions'),
    lang = require('../../lang');

module.exports = [
    [
        {value: '123', action: actions.numericKeyboard},
        '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')',
        {className: 'backspace', action: actions.backspace, value: ''}
    ],
    [
        {value: '#&$', action: actions.symbolsKeyboard},
        'й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', ':',
        {value: 'Очистить', action: actions.clear}
    ],
    [
        {className: 'uppercase', action: actions.uppercase, value: ''},
        'ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э', ';',
        {value: 'Готово', action: actions.done, className: 'yellowText'}
    ],
    [
        {value: lang.shortNames[lang.active], action: actions.changeLanguage, rowSpan: 2, className: 'lang'},
        'я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю', 'ъ', 'ё', '-',
        {value: 'Отмена', action: actions.cancel, className: 'cancel'}
    ],
    [
        ',', '.', '/',
        {value: 'Пробел', action: actions.space, colSpan: 5, className: 'blueText'},
        '_',
        {value: '', action: actions.moveCaretToLeft, className: 'arrow left'},
        {value: '', action: actions.moveCaretToRight, className: 'arrow right'},
        {value: '', action: actions.moveCaretToStart, className: 'arrow start'},
        {value: '', action: actions.moveCaretToEnd, className: 'arrow end'}
    ]
];
